import { Form, GenericFormField } from "@web/components/Forms/Form"
import { FieldValues, useForm } from "react-hook-form"
import styles from "./Form.module.scss"

type FormProps<T extends FieldValues> = {
  fields: GenericFormField<T>[]
  title: string
  onSubmit: (t: T) => void
  successText?: string
}
const TomboForm = <T extends FieldValues>({ title, fields, onSubmit, successText }: FormProps<T>) => {
  const formMethods = useForm<T>()

  return (
    <div className={styles.root}>
      <h3>{title}</h3>
      {successText ? (
        successText
      ) : (
        <Form formMethods={formMethods} onSubmit={onSubmit} fields={fields}>
          <button type="submit" className={styles.tomboButton}>
            Submit
          </button>
        </Form>
      )}
    </div>
  )
}
export default TomboForm
